import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import adminCategoryService from '../api/adminCategoryService';

const KEYS = {
    all: ['adminProductCategories'],
    detail: (id) => ['adminProductCategory', id]
};

export const useAdminProductCategories = (params = {}) => {
    return useQuery({
        queryKey: [...KEYS.all, params],
        queryFn: () => adminCategoryService.getAll(params).then((res) => res.data),
        staleTime: 5 * 60 * 1000
    });
};

export const useCreateAdminProductCategory = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload) => adminCategoryService.create(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: KEYS.all });
        }
    });
};

export const useUpdateAdminProductCategory = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, payload }) => adminCategoryService.update(id, payload),
        onSuccess: (_, { id }) => {
            queryClient.invalidateQueries({ queryKey: KEYS.all });
            queryClient.invalidateQueries({ queryKey: KEYS.detail(id) });
        }
    });
};
